import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryNav() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            内容分类
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            按类别浏览51cg黑料相关内容
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1.5 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}